import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { useTranslation } from 'modules/domains/list';

export const useManageUsersSectionTitle = (): ActionMenuOption => {
  const { t } = useTranslation();
  return {
    as: AllowedActionMenuElements.Title,
    content: t('indexPage.pageActions.manageUsersSection'),
    id: 'manage-users-title',
  };
};
